/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PricePredictionRequest
 */
export interface PricePredictionRequest {
    /**
     * 
     * @type {number}
     * @memberof PricePredictionRequest
     */
    vervotechPropertyId: number;
    /**
     * 
     * @type {Date}
     * @memberof PricePredictionRequest
     */
    checkin: Date;
    /**
     * 
     * @type {Date}
     * @memberof PricePredictionRequest
     */
    checkout: Date;
    /**
     * 
     * @type {number}
     * @memberof PricePredictionRequest
     */
    nightlyCashCost: number;
    /**
     * 
     * @type {string}
     * @memberof PricePredictionRequest
     */
    nightlyCashCostCurrency: string;
    /**
     * 
     * @type {number}
     * @memberof PricePredictionRequest
     */
    nightlyPointsCost?: number | null;
}

/**
 * Check if a given object implements the PricePredictionRequest interface.
 */
export function instanceOfPricePredictionRequest(value: object): value is PricePredictionRequest {
    if (!('vervotechPropertyId' in value) || value['vervotechPropertyId'] === undefined) return false;
    if (!('checkin' in value) || value['checkin'] === undefined) return false;
    if (!('checkout' in value) || value['checkout'] === undefined) return false;
    if (!('nightlyCashCost' in value) || value['nightlyCashCost'] === undefined) return false;
    if (!('nightlyCashCostCurrency' in value) || value['nightlyCashCostCurrency'] === undefined) return false;
    return true;
}

export function PricePredictionRequestFromJSON(json: any): PricePredictionRequest {
    return PricePredictionRequestFromJSONTyped(json, false);
}

export function PricePredictionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PricePredictionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'vervotechPropertyId': json['vervotech_property_id'],
        'checkin': (new Date(json['checkin'])),
        'checkout': (new Date(json['checkout'])),
        'nightlyCashCost': json['nightly_cash_cost'],
        'nightlyCashCostCurrency': json['nightly_cash_cost_currency'],
        'nightlyPointsCost': json['nightly_points_cost'] == null ? undefined : json['nightly_points_cost'],
    };
}

export function PricePredictionRequestToJSON(json: any): PricePredictionRequest {
    return PricePredictionRequestToJSONTyped(json, false);
}

export function PricePredictionRequestToJSONTyped(value?: PricePredictionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'vervotech_property_id': value['vervotechPropertyId'],
        'checkin': value['checkin'].toISOString().substring(0,10),
        'checkout': value['checkout'].toISOString().substring(0,10),
        'nightly_cash_cost': value['nightlyCashCost'],
        'nightly_cash_cost_currency': value['nightlyCashCostCurrency'],
        'nightly_points_cost': value['nightlyPointsCost'],
    };
}

